module.exports = __webpack_public_path__ + "static/img/guardians.4c1e7f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/guardians.jpg
// module id = 3Eqt
// module chunks = 0